import { Routes, Route } from 'react-router-dom';
import FlowMeasurementNew from '../../../pages/manage_database/FlowMeasurementNew';
import FlowMeasurementRecord from '../../../pages/manage_database/FlowMeasurementRecord';
import FlowMeasurementSampleRecord from '../../../pages/manage_database/FlowMeasurementSampleRecord';
import FlowMeasurementSearchChoice from '../../../pages/manage_database/FlowMeasurementSearchChoice';
import FlowMeasurementFastRecord from '../../../pages/manage_database/FlowMeasurementFastRecord';

const FlowMeasurementRoutes = () => {
    return <Routes>
         <Route 
            path='/new'
            element={<FlowMeasurementNew />}
          />
          <Route 
            path='/choice'
            element={<FlowMeasurementSearchChoice />}
          />
          <Route
            path='/record'
            element={<FlowMeasurementRecord />}
          />
          <Route
            path='/fast-record'
            element={<FlowMeasurementFastRecord />}
          />
          <Route 
            path='/sample'
            element={<FlowMeasurementSampleRecord />}
          />
    </Routes>
}

export default FlowMeasurementRoutes;
